import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Config } from 'src/app/constants/config';
import { ComplaintService } from 'src/app/services/services.index';
import {ComplaintDTO} from '../../models/ComplaintDTO';

@Component({
  selector: 'app-search-complaint',
  templateUrl: './search-complaint.component.html',
  styleUrls: ['./search-complaint.component.scss']
})
export class SearchComplaintComponent implements OnInit {

  formSearchComplaint: FormGroup;
  complaints: ComplaintDTO[];
  empty: boolean = false;
  loading: boolean = false;
  lastProcesalState: string;

  constructor(
    private _fb: FormBuilder,
    public _complaintService: ComplaintService,
  ) { }

  ngOnInit() {
    this.initialSetForm();
  }

  initialSetForm(): void {
    this.formSearchComplaint = this._fb.group({
      business_id: [null, [Validators.required]],
    });
  }

  searchComplaint(): void {
    this.empty = false;

    if (this.formSearchComplaint.invalid) {
      return;
    }

    this.loading = true;

    const business_id = this.formSearchComplaint.value.business_id;

    this._complaintService.getComplaint(business_id)
      .subscribe(res => {
        this.loading = false;
        this.complaints = res;
        /*if (res) {
          const sizeProcedures = res[0].procedures.length;

          
          if (sizeProcedures)
            this.lastProcesalState = res[0].procedures[sizeProcedures - 1].description;
          return;
        }*/

        this.empty = true;
      });
  }
}
